// extracted by mini-css-extract-plugin
export var container = "_c4-0";
export var icon = "_c4-1";
export var text = "_c4-2";